import { Skeleton } from '@/components/skeleton/skeleton'

export const SettingsLoading = () => {
  return (
    <>
      <Skeleton className="mb-2 h-6 w-1/4 rounded-md" />
      <Skeleton className="mb-8 h-10 rounded-md" />
      <Skeleton className="mb-2 h-6 w-1/4 rounded-md" />
      <Skeleton className="mb-4 h-10 rounded-md" />
    </>
  )
}
